'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FEW_MINUTES = exports.FEW_MINUTES = 'FEW_MINUTES';
var FEW_HOURS = exports.FEW_HOURS = 'FEW_HOURS';
var WITHIN_DAY = exports.WITHIN_DAY = 'WITHIN_DAY';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/typical-response-time/constants/StandardResponses.js
// module id = 577
// module chunks = 2 3